import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var View = createReactComponent("View", ["svg", defaultAttributes, [["path", {
  d: "M5 12s2.545-5 7-5c4.454 0 7 5 7 5s-2.546 5-7 5c-4.455 0-7-5-7-5z",
  key: "1i69hl"
}], ["path", {
  d: "M12 13a1 1 0 100-2 1 1 0 000 2z",
  key: "1b4zes"
}], ["path", {
  d: "M21 8V5a2 2 0 00-2-2H5a2 2 0 00-2 2v3m18 8v3a2 2 0 01-2 2H5a2 2 0 01-2-2v-3",
  key: "y1dmu8"
}]]]);
export default View;